
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        
        this.updateMedia()
        this.initQuantityHandlers();
        this.initSizeGuide()
        this.initModals()
        this.checkHeight()
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        $(window).resize($.throttle(50, () => {
          this.checkHeight()
        }))
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initPhotoSwipe() {
        if ($('.active-wrapper a.productImage').length > 0) {
          var pswpElement = document.querySelectorAll('.pswp')[0];
          var itemsArray = [];
          
          $($('.active-wrapper:not(.slick-cloned) a.productImage')).each(function( index ) {
            if ($(this).data("type") == 'video'){
              itemsArray.push({
                html: '<video playsinline loop autoplay muted><source src="'+$(this).find('source').attr("src")+'" type="'+$(this).find('source').attr("type")+'"></video>'
              });
            } else {
              itemsArray.push({
                src: $(this).attr("href"),
                w: 600,
                h: 800
              });
            }
  
            $(this).on('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              var options = { index: index, history: 0 }
              var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, itemsArray, options);
              gallery.init();

              setTimeout(function() {
                $('.pswp__zoom-wrap video').parent().addClass('no-zoom');
              }, 1000);
  
            });
          });
        }
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        if (target.dataset.optionName !== 'Color') {
          this.querySelector('[name="id"]').disabled = false
        }

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          let swatchScrollLeft = 0
          if (document.querySelector('.product-info-footer .swatch-color .product-form__input--swatch-list')) {
            swatchScrollLeft = document.querySelector('.product-info-footer .swatch-color .product-form__input--swatch-list').scrollLeft
          }
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('product-info'),
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          if (document.querySelector('.product-info-footer .swatch-color .product-form__input--swatch-list')) {
            document.querySelector('.product-info-footer .swatch-color .product-form__input--swatch-list').scrollLeft = swatchScrollLeft
          }

          this.initQuantityHandlers();
          this.initSizeGuide()
          this.initModals()
          this.checkHeight()
          this.initAfterPay()
          this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

          document.querySelector('#page').classList.remove('mode-overlay', 'overlay-light')
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            if (!!targetId) document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length && !this.querySelector('[name="id"]').disabled) {
          params.push(`option_values=${optionValues.filter(e => !!e).join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          document.querySelector('#page').classList.remove('mode-overlay', 'overlay-light')

          if (!variant) {
            this.setUnavailable();
            return;
          }

          const slideIndex = parseInt($('.main-images .slick-current').data('slick-index'))

          this.updateMedia(slideIndex);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#presale-message-${this.dataset.section}`)?.classList.remove('hide');

          this.productForm?.toggleSubmitButton(
            html.querySelector('.js-product-form-submit')?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          this.initQuantityHandlers();
          this.initSizeGuide()
          this.initModals()
          this.checkHeight()
          this.initAfterPay()
          this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          // input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId && !this.querySelector('[name="id"]').disabled ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(initialSlide = 0) {
        setTimeout(() => {
          $('.main-images').slick({
            initialSlide,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            waitForAnimate: false,
            arrows: false,
            dots: true
          })
        })

        this.initPhotoSwipe()
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      initSizeGuide() {
        const mesasuresTable = $('.js-product-description .table-guide.measures')

        if (mesasuresTable.length > 0) {
          $('.js-detailed-measures-title').removeClass('hide')

          mesasuresTable.insertAfter('.js-detailed-measures-title').removeClass('hide')
        }

        const table = $('.table-guide.size')
        const measureGuide = $('.how-to-measure')

        if (mesasuresTable.length === 0 && table.length === 0 && measureGuide.length === 0) {
          $('.swatch-size-info-wrapper').addClass('hide')
          $('.js-modal-btn[data-target="product-size-guide"]').addClass('hide')
        }

        if (table.length == 0) return;
        
        var values = false
        if ($('#detailed-measures-values').val()) {
          values = $('#detailed-measures-values').val().split('-').filter(function (e) { return e != '' })
        }

        if (!values) { return }
    
        var selects = table.find('td select');
        var tableDetailedMeasures = table.closest('.info-popup').find('.table-guide.measures');
        
        values.forEach(function(value) {
          for (var i=0; i<5; i++) {
            var parts = value.split(',');
            selects[i].options.add(new Option(parts[i],parts[i]));
          }
        })
        selects.on('change', function() {
          var index = this.selectedIndex;
          var self = this;
          selects.each(function(ix, select) {
            if (select != self) {
              select.selectedIndex = index;
              var $select = $(select);
              if ($select.hasClass('ui-selectmenu-source'))
                $select.selectmenu('refresh');
            }
    
          })
          var usSize = selects[0].value;
          filterDetailedMeasurements(usSize);
        });
        selects.each(function(ix, select) {
          Simplistic.customDropdown(select, {
            position: { my : "center top-65", at: "center center" },
            className: 'size-ddl'
          });
        });
    
        function filterDetailedMeasurements(usSize) {
          tableDetailedMeasures.find('tr').each(function(ix, tr) {
            if (ix>0) {
              var $tr = $(tr);
              if (usSize=='')
                $tr.show();
              else {
                if ($tr.find('td:eq(0)').text() == usSize)
                  $tr.show();
                else
                  $tr.hide();
              }
            }
          });
        }
    
      }

      initModals() {
        $('.js-modal-btn').click(e => {
          const target = $(e.currentTarget).data('target')
          if ($(`#${target}`).length > 0) {
            $(`#${target}`).show("slide", { direction: 'right' })

            $('body, html').css({overflow: 'hidden'});
          }
        })

        $('.info-popup').click(function(event) {
          if (event.target === this && event.offsetX < 0) {
            $(this).find('.close').click();
          }
        });

        $('.info-popup .close').click(e => {
          const popup = $(e.target.closest('.info-popup'))

          $(popup).hide("slide", { direction: 'right' })

          $('body, html').css({overflow: ''});
        })
      }

      initAfterPay() {
        if (typeof Afterpay !== 'undefined') window.Afterpay.init(jQuery)
      }

      checkHeight () {
        var mainImageHeight = ($(window).width() / 2) / $('.product-gallery-item__main').data('aspect')
        var pageContentHeight = $(window).height() - $('header').height()
        var infoContentHeight = $('.product-info .nav-and-main').outerHeight() + $('.product-info .product-info-footer').outerHeight()
        if (window.innerWidth > 900 && mainImageHeight > pageContentHeight) {
          if (infoContentHeight > pageContentHeight) {
            $('.product-info-height').css({'min-height': '0'})
          } else {
            $('.product-info-height').css({'min-height': infoContentHeight})
          }
          $('.product-gallery-item__main.bottom-align-image').css({'margin-top': 0 - (mainImageHeight - pageContentHeight)})
    
        } else {
          $('.product-info-height').css({'min-height': '0'})
          $('.product-gallery-item__main').css('margin-top', '0')
        }

        $('.product-info-footer').css('visibility', 'visible')
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
